module.exports = {
  name: "国创中心",  // 系统名称
  publicPath: "/",  // 公共路径，用于根目录部署还是非根目录部署，例如：/admin/
  outputDir: "dist",  // 打包时文件的输出位置默认"dist", 例如：dist/admin
  indexPath: "/",  // 登录之后跳转到的默认首页，例如：/platform/index
};
